import React from 'react';
import '../styles/Footer.css';
import Logo from '../assets/JK_LOGO.png';

function Footer() {
  return (
    <div className="footer">
      <img src={Logo} alt="JK Logo" className="footer-logo" />
      <p> &copy; 2026 alphakangaroo.com</p>
    </div>
  )
}

export default Footer;
